import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=d9701a42&"
import script from "./Builder.vue?vue&type=script&lang=js&"
export * from "./Builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9701a42')) {
      api.createRecord('d9701a42', component.options)
    } else {
      api.reload('d9701a42', component.options)
    }
    module.hot.accept("./Builder.vue?vue&type=template&id=d9701a42&", function () {
      api.rerender('d9701a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Builder.vue"
export default component.exports